export default "<app-create-profile [isEditProfile]=\"true\"></app-create-profile>"